import Modifier from 'ember-modifier';

import { service } from '@ember/service';

/**
 * Toggles given class when element is just off-screen above.
 * For example, heading element can be styled fixed to the top of the viewport.
 * An example use of onChange callback would be to set a variable so that
 * classes may be conditionally applied to other related elements.
 * @param {string} [named.class] Class to apply when element is just off-screen
 * @param {string} [named.activate] Stickies by name to activate under
 * @param {function(boolean)} [named.onChange] Called when element moves on/off-screen
 */
export default class StickyModifier extends Modifier {
  @service sticky;

  instance;

  modify(element, params, { activate, class: cls, onChange }) {
    if (this.instance) {
      return;
    }
    this.sticky.activate(this.instance = {
      element, activate, class: cls, onChange
    });
  }

  willRemove() {
    this.sticky.deactivate(this.instance);
  }
}
